/* =========================================================
   ÉLAN MARAIS — Klaviyo Wishlist Digest (Route B)
   - Schedules a single digest event after 30 min inactivity
   - Sends ALL current wishlist items (array) in ONE event
   - Anti-duplicate via stable hash
   - Supports wishlist stored as:
       A) ["handle-1","handle-2"]   (your current format)
       B) [{...item objects...}]
       C) {items:[...]}
   ========================================================= */

(function () {
  "use strict";

  // ====== CONFIG ======
  var LS_WISHLIST_KEY = "em_wishlist_v1";
  var LS_DUE_AT_KEY = "em_wishlist_digest_due_at";
  var LS_LAST_HASH_KEY = "em_wishlist_digest_last_hash";
  var LS_LAST_SENT_AT_KEY = "em_wishlist_digest_last_sent_at";

  var EVENT_NAME = "Wishlist Digest Ready";

  // Production: 30 minutes
  var DEFAULT_DELAY_MS = 30 * 60 * 1000;

  // For fast testing: add ?emDigestTest=1 to any URL -> 60 seconds delay
  var TEST_DELAY_MS = 60 * 1000;

  function getDelayMs() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("emDigestTest") === "1") return TEST_DELAY_MS;
    } catch (e) {}
    return DEFAULT_DELAY_MS;
  }

  // ====== UTILS ======
  function now() {
    return Date.now();
  }

  function safeJsonParse(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  // Stable stringify (sort keys) so hash is consistent
  function stableStringify(obj) {
    if (obj === null || typeof obj !== "object") return JSON.stringify(obj);
    if (Array.isArray(obj)) return "[" + obj.map(stableStringify).join(",") + "]";
    var keys = Object.keys(obj).sort();
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      parts.push(JSON.stringify(k) + ":" + stableStringify(obj[k]));
    }
    return "{" + parts.join(",") + "}";
  }

  // Simple fast hash (djb2)
  function hashString(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i);
      hash = hash & 0xffffffff;
    }
    // Convert to unsigned and base36
    return (hash >>> 0).toString(36);
  }

  function learnqReady() {
    return (typeof window._learnq !== "undefined" && window._learnq && typeof window._learnq.push === "function");
  }

  function trackToKlaviyo(payload) {
    if (!learnqReady()) return false;
    window._learnq.push(["track", EVENT_NAME, payload]);
    return true;
  }

  function scheduleDueAt() {
    var delay = getDelayMs();
    var dueAt = now() + delay;
    localStorage.setItem(LS_DUE_AT_KEY, String(dueAt));
    return dueAt;
  }

  function getDueAt() {
    var v = localStorage.getItem(LS_DUE_AT_KEY);
    var n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) ? n : null;
  }

  function clearSchedule() {
    localStorage.removeItem(LS_DUE_AT_KEY);
  }

  function uniqStrings(arr) {
    var out = [];
    var seen = {};
    for (var i = 0; i < arr.length; i++) {
      var s = arr[i];
      if (!s) continue;
      s = String(s);
      if (seen[s]) continue;
      seen[s] = true;
      out.push(s);
    }
    return out;
  }

  // ====== WISHLIST READ ======
  // Supports:
  //  - ["handle","handle2"]   <-- your current format
  //  - [{object}, {object}]
  //  - {items:[...]}
  function readWishlistRaw() {
    var raw = localStorage.getItem(LS_WISHLIST_KEY);
    var data = safeJsonParse(raw, null);

    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.items)) return data.items;
    return [];
  }

  function normalizeObjectItem(it) {
    if (!it || typeof it !== "object") return null;
    return {
      product_id: it.product_id || it.productId || it.id || null,
      variant_id: it.variant_id || it.variantId || it.variant || null,
      product_title: it.product_title || it.title || it.productTitle || "",
      product_url: it.product_url || it.url || it.productUrl || "",
      product_image: it.product_image || it.image || it.featured_image || it.productImage || "",
      price: (it.price != null ? it.price : (it.price_cents != null ? it.price_cents : null)),
      currency: it.currency || it.currency_code || it.currencyCode || null,
      handle: it.handle || it.product_handle || it.productHandle || ""
    };
  }

  // ====== HANDLE -> SHOPIFY PRODUCT FETCH ======
 function fetchProductByHandle(handle) {
  var url = "/products/" + encodeURIComponent(handle) + ".js";
  return fetch(url, { cache: "no-store" }).then(function (res) {
    if (!res.ok) throw new Error("product_fetch_failed:" + handle + ":" + res.status);

    var ct = (res.headers && res.headers.get) ? (res.headers.get("content-type") || "") : "";
    if (ct.indexOf("application/json") === -1 && ct.indexOf("text/json") === -1) {
      // Geen JSON → waarschijnlijk HTML (password/redirect). Forceer fallback.
      throw new Error("product_fetch_not_json:" + handle + ":" + ct);
    }
    return res.json();
  });
}


  function pickDefaultVariant(p) {
    if (p && p.variants && p.variants.length) return p.variants[0];
    return null;
  }

  function buildItemFromShopifyProduct(p) {
    var v = pickDefaultVariant(p);

    // p.url from Shopify .js is usually like "/products/handle"
    var url = (p && p.url) ? (window.location.origin + p.url) : (window.location.origin + "/products/" + p.handle);

    return {
      product_id: p.id || null,
      variant_id: v ? (v.id || null) : null,
      product_title: p.title || "",
      product_url: url || "",
      product_image: p.featured_image || (p.images && p.images[0]) || "",
      // Keep both, so Klaviyo can render either
      price_cents: v && v.price != null ? v.price : null,
      price: v && v.price != null ? (Number(v.price) / 100).toFixed(2) : null,
      currency: "EUR",
      handle: p.handle || ""
    };
  }

  // Core builder: returns normalized items (objects) no matter what storage format is
  function getWishlistItemsAsync() {
    var rawItems = readWishlistRaw();

    // Case A: array of strings/handles
    var allStrings = rawItems.length > 0 && rawItems.every(function (x) { return typeof x === "string"; });

    if (allStrings) {
      var handles = uniqStrings(rawItems);
      if (!handles.length) return Promise.resolve([]);

      // Fetch all handles (parallel)
      var promises = handles.map(function (h) {
        return fetchProductByHandle(h)
          .then(function (p) { return buildItemFromShopifyProduct(p); })
 .catch(function () {
  // Fallback item (zodat digest niet leeg wordt)
  return {
    product_id: null,
    variant_id: null,
    product_title: h,
    product_url: window.location.origin + "/products/" + h,
    product_image: "",
    price_cents: null,
    price: null,
    currency: "EUR",
    handle: h
  };
});


      });

      return Promise.all(promises).then(function (arr) {
        return arr.filter(Boolean);
      });
    }

    // Case B/C: object items already stored
    var normalized = rawItems
      .map(function (it) { return normalizeObjectItem(it); })
      .filter(Boolean);

    // If those objects have no title/url/image, we still return them,
    // but they might be "thin". That's fine for now.
    return Promise.resolve(normalized);
  }

  function shouldSend(items) {
    return !!(items && items.length);
  }

  function computeDigestHash(items) {
    // Only hash the fields that matter for “same digest”
    var compact = items.map(function (it) {
      return {
        product_id: it.product_id,
        variant_id: it.variant_id,
        product_url: it.product_url,
        price: it.price != null ? it.price : it.price_cents
      };
    });
    return hashString(stableStringify(compact));
  }

  // ====== SEND (ASYNC) ======
  function trySendDigest(reason) {
    return getWishlistItemsAsync().then(function (items) {
      if (!shouldSend(items)) {
        clearSchedule();
        return { sent: false, why: "empty_wishlist" };
      }

      var digestHash = computeDigestHash(items);
      var lastHash = localStorage.getItem(LS_LAST_HASH_KEY);

      if (lastHash && lastHash === digestHash) {
        clearSchedule();
        return { sent: false, why: "duplicate_hash" };
      }

      var payload = {
        wishlist_count: items.length,
        items: items,
        digest_id: digestHash,
        digest_reason: reason || "timer",
        digest_sent_at: new Date().toISOString()
      };

      var ok = trackToKlaviyo(payload);
      if (!ok) {
        // If Klaviyo isn't ready yet, keep schedule and try again later
        return { sent: false, why: "learnq_not_ready" };
      }

      localStorage.setItem(LS_LAST_HASH_KEY, digestHash);
      localStorage.setItem(LS_LAST_SENT_AT_KEY, String(now()));
      clearSchedule();

      return { sent: true, why: "sent", hash: digestHash, count: items.length };
    }).catch(function (err) {
      // don't kill schedule; return debug info
      return { sent: false, why: "exception", error: String(err && err.message ? err.message : err) };
    });
  }

  // ====== CHECKER ======
  var CHECK_EVERY_MS = 15 * 1000;
  var intervalId = null;

  function startChecker() {
    if (intervalId) return;
    intervalId = window.setInterval(function () {
      var dueAt = getDueAt();
      if (!dueAt) return;
      if (now() >= dueAt) {
        trySendDigest("interval");
      }
    }, CHECK_EVERY_MS);
  }

  // ====== PUBLIC API ======
  window.EM_WISHLIST_DIGEST = {
    onChange: function () {
      scheduleDueAt();
      startChecker();
    },
    forceSendNow: function () {
      return trySendDigest("manual_force");
    },
    debug: function () {
      // return Promise so you can see real fetched items in console
      return getWishlistItemsAsync().then(function (items) {
        return {
          dueAt: getDueAt(),
          lastHash: localStorage.getItem(LS_LAST_HASH_KEY),
          lastSentAt: localStorage.getItem(LS_LAST_SENT_AT_KEY),
          items: items
        };
      });
    }
  };

  // Keep checker alive if scheduled
  if (getDueAt()) startChecker();

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      var dueAt = getDueAt();
      if (dueAt && now() >= dueAt) trySendDigest("visibility");
    }
  });

  window.addEventListener("storage", function (e) {
    if (!e) return;
    if (e.key === LS_WISHLIST_KEY) {
      window.EM_WISHLIST_DIGEST.onChange();
    }
  });
})();
